<template>
    <div class="ui fluid search selection dropdown">
        <i class="dropdown icon"></i>
        <div class="default text">Select Page</div>
        <div class="menu">
            <div class="item" :data-value="page.id" v-for="page in pages">{{ page.title }}</div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'admin-page-selection-dropdown',

  props: ['pages', 'selection'],

  mounted() {
    let vm = this;

    $(this.$el).dropdown({
      onChange(value, text, $choice) {
        vm.$emit('selection', value);
      },
    });

    if (this.selection !== null) $(this.$el).dropdown('set selected', this.selection);
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/AdminPageSelectionDropdown.vue